/* eslint-disable tailwindcss/no-arbitrary-value */
import { HTMLProps, PropsWithChildren } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@ui/lib';

export const cardVariantTypes = [
  'flat',
  'elevated',
  'outlined',
  'secondary',
  'positive',
  'warning',
  'negative',
  'accent',
] as const;

const cardVariants = cva(
  'flex w-full flex-col items-center justify-start rounded-2xl p-card-padding',
  {
    variants: {
      variant: {
        flat: 'bg-primary-surface',
        elevated: 'bg-primary-surface shadow-line shadow-[0_1px_8px]',
        outlined: 'border border-shadow',
        secondary: 'bg-secondary-surface',
        positive: 'bg-positive-weak',
        warning: 'bg-warning-weak',
        negative: 'bg-negative-weak',
        accent: 'bg-accent1-weakest',
      } satisfies Record<(typeof cardVariantTypes)[number], string>,
    },
    defaultVariants: {
      variant: 'flat',
    },
  },
);

export type CardProps = VariantProps<typeof cardVariants> &
  HTMLProps<HTMLDivElement>;

export const Card = ({
  children,
  className,
  variant,
}: PropsWithChildren<CardProps>) => {
  return (
    <div
      data-testid="card"
      className={cn(cardVariants({ variant }), className)}
    >
      {children}
    </div>
  );
};
